export default "__VITE_ASSET__CxNG6$QN__"